import { IoBusiness } from 'react-icons/io5';
import PlaceHolderItemList from './loader/PlaceHolderItemList';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function OrganizationItem({ 
    children,
    organization,
    isList = false,
    onClick = () => {},
    isSkeleton,
    showCreatedAt = false
}) {

    const ListComponent = isList ? 'a' : 'div';
    const isNew = organization?.created_at && moment(organization?.created_at).isAfter(moment().subtract(7, 'days'));
    const createdAtLabel = organization?.created_at ? moment(organization.created_at).format('DD/MM/YY') : null;

    return (
        <li onClick={() => onClick(organization)}>
            <ListComponent className="item">
                <div className={`icon-box me-05 position-relative`}>
                    <IoBusiness />
                    {isNew && !isSkeleton && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`org-new-tooltip-${organization?.id || 'new'}`}>NEW</Tooltip>}
                        >
                            <span
                                className="badge badge-primary badge-empty position-absolute"
                                style={{
                                    top: '2px',
                                    right: '2px',
                                    border: '2px solid #fff',
                                    boxSizing: 'content-box'
                                }}
                            />
                        </OverlayTrigger>
                    )}
                </div>
                {isSkeleton ? <PlaceHolderItemList hideSecondLine /> : <>
                    <div className="in">
                        <div>
                            <span>
                                {organization.display_name}
                            </span>
                            {showCreatedAt && createdAtLabel && (
                                <div className="text-muted" style={{ fontSize: '10px' }}>
                                    Creata il {createdAtLabel}
                                </div>
                            )}
                        </div>
                        <div>
                            {children}
                        </div>
                    </div>
                </>}
            </ListComponent>
        </li>
    );
}
